import angular from 'angular'
import globalFn from './globalFnFactory'

export default angular
    .module('app.globalFn', [])
    .factory('globalFn', globalFn)
    .name



// WEBPACK FOOTER //
// ./src/components/globalFn/index.js